import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import axios from "axios";


import { connect } from "react-redux";
import { registerUser } from "../../actions/authActions";
import {
  getAccommodationsForProperty, getPropertiesForCompany,
  deleteProperty, deleteAccommodation, changePropertyStatus, changeAccommodationStatus
} from "../../actions/dealsActions";


//import axios from "axios";
//import classnames from "classnames";

import AccommodationForm from "../deals/forms/AccommodationForm";
import PropertyForm from "../deals/forms/PropertyForm";

import TextFieldGroup from "../common/TextFieldGroupPlain";

class AdminProperties extends Component {
  constructor() {
    super();
    this.state = {
      name: "",
      email: "",
      company: "",
      company_id: "",
      password: "",
      password2: "",
      displaystr: 'what',
      isadmin: false,
      properties_ary: [],
      selected_property: null,
      accommodations_ary: [],
      selected_accommodation: null,
      showpropform: false,
      showaccoms: false,
      showaccomform: false,
      showaddaccombutton: false,

      errors: {}
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    if (this.props.auth.isAuthenticated) {
      // this.props.history.push("/dashboard");
      let role = this.props.auth.user.role;
      let cid = this.props.auth.user.company_id;
      let isadmin = false;
      if (role === 'admin') isadmin = true;
      this.setState({
        name: this.props.auth.user.name,
        email: this.props.auth.user.email,
        company: this.props.auth.user.company,
        company_id: this.props.auth.user.company_id,
        isadmin: isadmin
      })
      this.doGetProperties(cid);
    }

  }

  // if we have errors this will run
  // componentWillReceiveProps(nextProps) {
  //   //console.log("register componentWillReceiveProps");
  //   if (nextProps.errors) {
  //     this.setState({ errors: nextProps.errors });
  //     // setState triggers a render
  //   }
  // }
  static getDerivedStateFromProps(props, state) {
    return {
      errors: props.errors
    };
  }

  //componentDidUpdate(prevProps) {
  // Typical usage (don't forget to compare props):
  // if (this.props.errors) {
  //   this.setState({ errors: this.props.errors });
  // }
  //}

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onCancelClick(e) {
    e.preventDefault();
    window.location = "/";
  }

  onSubmit(e) {
    // e.preventDefault();

    // const newUser = {
    //   name: this.state.name,
    //   email: this.state.email,
    //   company: this.state.company,
    //   company_id: this.state.company_id,
    //   password: this.state.password,
    //   password2: this.state.password2,
    //   role: 'user'

    // };


    // this.props.registerUser(newUser, this.props.history);

  }

  getProperties = (e) => {
    e.preventDefault();
    let cid = this.props.auth.user.company_id;
    this.doGetProperties(cid);

    // this.setState({ selected_property: null, accommodations_ary: [], showpropform: false, showaccomform: false, selected_accommodation: null });
    // this.props.getPropertiesForCompany(cid);
  }

  doGetProperties = (cid) => {
    // let cid = this.props.auth.user.company_id;
    this.setState({ selected_property: null, accommodations_ary: [], showpropform: false, showaccomform: false, selected_accommodation: null });
    this.props.getPropertiesForCompany(cid);
  }

  deleteProperty = (e, property) => {
    e.preventDefault();
    // let link = "/api/deals/admin_get_properties";
    //let cid = this.props.auth.user.company_id;
    //console.log('delete property', propid);
    // this.setState({ selected_property: null, accommodations_ary: [], selected_accommodation: null });
    this.props.deleteProperty(property);


  }






  showAddPropertyForm = (e) => {
    e.preventDefault();
    // let accoms = this.state.properties_ary;
    //  let taccom = accoms.filter((item) => item._id === accomid);
    //console.log('selected acom is ', taccom);
    let cid = this.props.auth.user.company_id;
    let prop = {};
    prop['which'] = 'create';
    prop['company_id'] = cid;
    prop['timemillis'] = Date.now();
    prop['prop_lat'] = 40.485;
    prop['prop_lon'] = -106.8317;

    prop['id'] = 'PID_999';
    prop['photo_path'] = 'BLANK';

    // FOR DEVELOPMENT PURPOSES PREFILL OBJ

    prop['name'] = 'name';
    prop['description'] = 'description';
    prop['thumbnail'] = 'thumbnail';
    prop['address'] = 'address';
    prop['city'] = 'city';
    prop['state'] = 'state';
    prop['zip'] = '87544';
    prop['latitude'] = 654321;
    prop['longitude'] = 123456;
    prop['region'] = 'region';
    prop['country'] = 'country';
    prop['url'] = 'url';
    prop['stars'] = 3;
    prop['status_flag'] = '0';



    this.setState({ selected_property: prop, showpropform: true, showaccoms: false, showaccomform: false, selected_accommodation: null });
  }

  showPropertyForm = (e, prop) => {
    e.preventDefault();
    // let accoms = this.state.properties_ary;
    prop['which'] = 'modify';
    prop['timemillis'] = Date.now();
    prop['prop_lat'] = prop['latitude']
    prop['prop_lon'] = prop['longitude']
    //  let taccom = accoms.filter((item) => item._id === accomid);
    //console.log('selected acom is ', taccom);
    this.setState({ selected_property: prop, showpropform: true, showaccoms: false, showaccomform: false, selected_accommodation: null });
  }

  changePropertyStatus = (e, propid, status) => {
    console.log('change property status', propid, status);
    this.props.changePropertyStatus(propid, status);
  }

  //**************************/
  // ACCOMMODATIONS
  //*************************/

  getAccommodations = (e, prop) => {
    e.preventDefault();
    let propid = prop._id;
    this.setState({ selected_property: prop, showaddaccombutton: true, showaccoms: true, showpropform: false, showaccomform: false, selected_accommodation: null });
    this.props.getAccommodationsForProperty(propid);
  }

  showAddAccommodationForm = (e) => {
    e.preventDefault();
    let cid = this.props.auth.user.company_id;
    let sp = this.state.selected_property;
    if (!sp) {
      sp = this.props.deals.current_properties[0];
    }
    console.log(sp);
    let accom = {};
    accom['which'] = 'create';
    accom['company_id'] = cid;
    accom['id'] = 'AID_999';

    // FOR DEVELOPMENT PURPOSES PREFILL OBJ

    accom['title'] = 'title of the accommodations';
    accom['room_type'] = 'standard';
    accom['categories'] = 'categories';
    accom['booking_url'] = 'booking_url';
    accom['bedrooms'] = 3;
    accom['baths'] = 3;
    accom['price'] = 1000;
    accom['retail'] = 1500;
    accom['lok'] = 10;
    accom['ppn'] = 50;
    accom['status_flag'] = 0;
    accom['property_key'] = sp['_id'];
    accom['timemillis'] = Date.now();



    // let accoms = this.state.accommodations_ary;
    //let taccom = accoms.filter((item) => item._id === accomid);
    //console.log('selected acom is ', taccom);
    this.setState({ selected_accommodation: accom, showpropform: false, showaccomform: true });
  }
  showAccommodationForm = (e, accom) => {
    e.preventDefault();
    accom['which'] = 'modify';
    accom['timemillis'] = Date.now();
    // let accoms = this.state.accommodations_ary;
    //let taccom = accoms.filter((item) => item._id === accomid);
    //console.log('selected acom is ', taccom);
    this.setState({ selected_accommodation: accom, showpropform: false, showaccomform: true });
  }

  deleteAccommodation = (e, accomid) => {
    e.preventDefault();
    // let link = "/api/deals/admin_get_properties";
    //let cid = this.props.auth.user.company_id;
    //  console.log('delete deleteAccommodation', accomid);
    this.props.deleteAccommodation(accomid);
  }

  changeAccommodationStatus = (e, accomid, status) => {
    console.log('change accommodation status', accomid);
    this.props.changeAccommodationStatus(accomid, status);
  }




  adjustDates = (e) => {
    e.preventDefault();
    let link = "/api/modify/adjust_dates";
    let mindate = this.props.deals.min_start;
    let qobj = { mindate: mindate };
    axios
      .post(link, qobj)
      //.get(link2)
      .then(res => {
        //  console.log(res);
        alert('dates changed')
        // let rstr = JSON.stringify(res.data);
        //  this.setState({ properties_ary: res.data, selected_accommodation: null, displaystr: rstr });
      }).catch(err => {
        console.log("advertise actions error ", err);
      });

  }



  render() {
    const { errors } = this.state;
    const { displaystr } = this.state;
    //const { properties_ary } = this.state;
    let { selected_property } = this.state;
    const accommodations_ary = this.props.deals.current_accommodations;
    const properties_ary = this.props.deals.current_properties;
    // console.log('current accom from props', accommodations_ary);
    const { selected_accommodation } = this.state;
    const { isadmin } = this.state;

    const { showpropform } = this.state;

    const { showaccoms } = this.state;
    const { showaccomform } = this.state;
    const { showaddaccombutton } = this.state;


    if (!selected_property) {
      selected_property = properties_ary[0];
    }



    let props_template = properties_ary.map((property, index) => (
      <tr key={index}>
        <td>
          <a className="btn btn-xs btn-info"
            href="#" onClick={(e) => this.showPropertyForm(e, property)} >{property.id}</a>
        </td>
        <td>{property.company_id}</td>
        <td>{property.name}</td>
        <td>{property.city}</td>
        <td>{property.state}</td>
        <td>{property.latitude}</td>
        <td>{property.longitude}</td>
        <td>
          <a className="btn btn-xs btn-info"
            href="#" onClick={(e) => this.changePropertyStatus(e, property._id, property.status_flag)} >{property.status_flag}</a>

        </td>
        <td>
          <a className="btn btn-xs btn-info"
            href="#" onClick={(e) => this.deleteProperty(e, property)} >delete</a>&nbsp;
            <a className="btn btn-xs btn-info"
            href="#" onClick={(e) => this.getAccommodations(e, property)} >accom</a>
        </td>
      </tr>
    ));

    let accoms_template = accommodations_ary.map((accom, index) => (
      <tr key={index}>
        <td>
          <a className="btn btn-xs btn-info"
            href="#" onClick={(e) => this.showAccommodationForm(e, accom)} >{accom.id}</a>
        </td>
        <td>{accom.title}</td>
        <td>{accom['start_date']}</td>
        <td>{accom['end_date']}</td>
        <td>{accom.price}</td>
        <td>{accom.lok}</td>
        <td>{accom.ppn}</td>
        <td>{accom.bedrooms}</td>
        <td>
          <a className="btn btn-xs btn-info"
            href="#" onClick={(e) => this.changeAccommodationStatus(e, accom._id, accom.status_flag)} >{accom.status_flag}</a>&nbsp;


          </td>
        <td><a className="btn btn-xs btn-info"
          href="#" onClick={(e) => this.deleteAccommodation(e, accom._id)} >delete</a></td>

      </tr>
    ));


    return (
      <div>







        <div className="dashboardall">
          <h4>Manage Properties</h4>
          <a className="btn btn-sm btn-info"
            href="#" onClick={(e) => this.getProperties(e)} >Properties</a>&nbsp;
            <a className="btn btn-sm btn-info"
            href="#" >Accommodations</a>&nbsp;
            {isadmin ? (
            <a className="btn btn-sm btn-info"
              href="#" onClick={(e) => this.adjustDates(e)} >Adjust Dates</a>
          ) : (null)}
          <div>

            {properties_ary.length > 0 ? (
              <div>
                <div style={{ maxHeight: "200px", overflowY: "scroll" }}>
                  <p style={{ width: "100%", textAlign: "center" }}>Properties</p>
                  <table style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th>id</th><th>co</th><th>name</th><th>city</th>
                        <th>state</th><th>lat</th><th>lon</th><th>status</th><th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {props_template}
                    </tbody>
                  </table>
                </div>


              </div>

            ) : (
                null

              )}
            <div style={{ marginTop: "20px" }}>
              <a className="btn btn-sm btn-info"
                href="#" onClick={(e) => this.showAddPropertyForm(e)} >Add Property</a>
            </div>

          </div>
          {showpropform ? (
            <PropertyForm property={selected_property} />
          ) : (null)}



          {showaccoms && accommodations_ary.length > 0 ? (
            <div>
              <p style={{ width: "100%", marginTop: "20px", textAlign: "center" }}>Accommodations {selected_property['name']}</p>
              <table style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>id</th><th>title</th><th>start</th><th>end</th><th>price</th>
                    <th>lok</th><th>ppn</th><th>beds</th><th>status</th><th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {accoms_template}
                </tbody>
              </table>


            </div>
          ) : (
              null
            )}
          {showaddaccombutton ? (
            <div style={{ marginTop: "20px" }}>
              <a className="btn btn-sm btn-info"
                href="#" onClick={(e) => this.showAddAccommodationForm(e)} >Add Accommodation</a>
            </div>
          ) : (null)}


          {showaccomform ? (
            <AccommodationForm accom={selected_accommodation} />
          ) : (null)}




        </div>



      </div>

    );
  }
}

// this is good practice because it will help debugging
// it is not checked when in production mode.
//onClick={(e) => props.gotoBooking(e, obj.accommodations.booking_url)} 
AdminProperties.propTypes = {
  registerUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

// map errors to this component
// then we can use this.props.auth.user etc
// since we mapped error, we can use componentWillReceiveProps method
const mapStateToProps = state => ({
  auth: state.auth,
  deals: state.deals,
  errors: state.errors
});
// the state.auth above comes from rootReducer in index.js in reducers.

export default connect(
  mapStateToProps,
  {
    registerUser, getAccommodationsForProperty, getPropertiesForCompany,
    deleteProperty, deleteAccommodation, changePropertyStatus, changeAccommodationStatus
  }
)(withRouter(AdminProperties));
// wrap the Register with withRouter so the authAction can use history to redirect



// WEBPACK FOOTER //
// ./src/components/auth/AdminProperties.js